var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.schema.title,"message":_vm.schema.description}},[_c('b-input',{attrs:{"value":_vm.value,"placeholder":_vm.schema.example},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }